
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 36C8.025 36 0 27.975 0 18S8.025 0 18 0s18 8.025 18 18-8.025 18-18 18zm0-7.125l1.35-1.35L18 22.35l-1.35 5.175 1.35 1.35zm-1.725-.075l-.675 2.55 1.575-1.575-.9-.975zm3.45 0l-.9.9 1.575 1.575-.675-2.475zM21 33.45l-3-3-3 3c.975.15 1.95.3 3 .3s2.025-.075 3-.3zm-3-31.2C9.3 2.25 2.25 9.3 2.25 18c0 6.9 4.425 12.75 10.575 14.85L16.2 20.325c-.75-.525-1.2-1.425-1.2-2.4 0-1.65 1.35-3 3-3s3 1.35 3 3c0 .975-.45 1.8-1.2 2.4l3.375 12.525A15.673 15.673 0 0033.75 18C33.75 9.3 26.7 2.25 18 2.25zM28.275 25.8c-.375.45-1.05.6-1.575.225-.525-.375-.6-1.05-.225-1.5 0 0 2.025-2.7 2.025-6.525s-2.025-6.525-2.025-6.525c-.375-.45-.3-1.125.225-1.5s1.2-.225 1.575.225c.15.15 2.475 3.225 2.475 7.8 0 4.575-2.325 7.65-2.475 7.8zM22.8 22.875c-.45-.45-.375-1.275.075-1.725 0 0 1.125-1.2 1.125-3.15s-1.125-3.075-1.125-3.15c-.45-.45-.45-1.2-.075-1.725.45-.525 1.125-.525 1.575-.075.075.075 1.875 1.95 1.875 4.95s-1.8 4.875-1.875 4.95c-.45.45-1.125.375-1.575-.075zm-9.6 0c-.45.45-1.125.525-1.575.075C11.55 22.8 9.75 21 9.75 18s1.8-4.8 1.875-4.95c.45-.45 1.2-.45 1.575.075.45.45.375 1.275-.075 1.725 0 .075-1.125 1.2-1.125 3.15s1.125 3.15 1.125 3.15c.45.45.525 1.2.075 1.725zm-3.9 3.15c-.525.375-1.2.225-1.575-.225-.15-.15-2.475-3.225-2.475-7.8 0-4.575 2.325-7.65 2.475-7.8.375-.45 1.05-.6 1.575-.225.525.375.6 1.05.225 1.5 0 0-2.025 2.7-2.025 6.525s2.025 6.525 2.025 6.525c.375.45.225 1.125-.225 1.5z","fill":"#FC7E0F","fill-rule":"evenodd"}})])
          )
        }
      }
    